var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle129(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "421.8574717454065 535.2799036556547 11.484807361852347 11.750096344345252",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M426.82,543.03c-.27-.51-.86-1.16-.95-1.88-.13-1.09.77-1.85,1.85-1.87.89-.01,1.67.76,1.62,1.59-.07,1.23-1.11,2.27-2.53,2.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle129);
export default __webpack_public_path__ + "static/media/twinkle-1-29.c591a83a2dc51ad52cf612e835fc3639.svg";
export { ForwardRef as ReactComponent };